module.exports = __webpack_public_path__ + "static/img/10_yellow.3357dec3.jpg";